import { defineMessages } from 'react-intl';

export default defineMessages({
    ratingYourPolicyMessage: {
        id: 'rewrite.eh.directives.MultiQuoteView.Please wait while we rate your policy...',
        defaultMessage: 'Please wait while we rate your policy...'
    },
    creatingYourOfferingMessage: {
        id: 'rewrite.eh.directives.MultiQuoteView.Please wait while we create your offering...',
        defaultMessage: 'Please wait while we create your offering...'
    },
    baseCoverages: {
        id: 'rewrite.eh.directives.HoOfferingSelection.defaultBaseCoverages.General Coverages',
        defaultMessage: 'General Coverages'
    },
    additionalCoverages: {
        id: 'rewrite.eh.directives.HoOfferingSelection.defaultAdditionalCoverages.Additional Coverages',
        defaultMessage: 'Additional Coverages'
    },
    sectionICoverages: {
        id: 'rewrite.eh.directives.HoOfferingSelection.defaultAdditionalCoverages.sectionICoverages',
        defaultMessage: 'Section I Coverages'
    },
    sectionIICoverages: {
        id: 'rewrite.eh.directives.HoOfferingSelection.defaultAdditionalCoverages.sectionIICoverages',
        defaultMessage: 'Section II Coverages'
    },
    deductibles: {
        id: 'rewrite.eh.directives.HoOfferingSelection.defaultAdditionalCoverages.Deductibles',
        defaultMessage: 'Deductibles'
    }
});
